import { render, staticRenderFns } from "./praticasAluno.vue?vue&type=template&id=258d3be5"
import script from "./praticasAluno.vue?vue&type=script&lang=js"
export * from "./praticasAluno.vue?vue&type=script&lang=js"
import style0 from "./praticasAluno.vue?vue&type=style&index=0&id=258d3be5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports